import { render, staticRenderFns } from "./VipCradDialog.vue?vue&type=template&id=8aa35c2e&scoped=true&"
import script from "./VipCradDialog.vue?vue&type=script&lang=js&"
export * from "./VipCradDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa35c2e",
  null
  
)

export default component.exports